// extracted by mini-css-extract-plugin
module.exports = {"root":"price-value-frequency_root__RSQvF"};